// extracted by mini-css-extract-plugin
export var productImage = "_pj-1";
export var viewLink = "_pj-2";
export var wishlistItem = "_pj-0";